import { DateTimeFormat } from '@occc-app/lib/date';
import { titleByTimeWindow } from '@occc-app/routes/Audience/constants';
import { readableDate } from '@occc-app/lib/format';
import { NO_DATA_PLACEHOLDER } from '@occc/ui-design-system';

import { PeriodValues } from '../../types';

const DATE_FORMAT = DateTimeFormat.DateTime12h;

export const getTimePeriodText = ({
  relativeMonthsBack,
  timeWindow,
  startDate,
  endDate,
}: PeriodValues): string => {
  if (timeWindow) {
    return titleByTimeWindow[timeWindow];
  }

  if (startDate && endDate) {
    return `${readableDate(startDate, DATE_FORMAT)} - ${readableDate(endDate, DATE_FORMAT)}`;
  }

  if (relativeMonthsBack === 1) {
    return 'Previous Month';
  }

  return NO_DATA_PLACEHOLDER;
};
